import { ICON_DOCUMENT } from '@global/constants';
import { RoutePaths } from '@global/routePaths';

export const contractSteps = [
  {
    id: 'contract',
    title: 'STEPS.CONTRACT.TITLE',
    iconClass: ICON_DOCUMENT,
    steps: [
      // Policyholder data
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
      // Policyholder contact
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
      // Policyholder address
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
      // Tax deduction
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
      // Partner data
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
      // Previous insurance
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
      // Payment
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
      // Sepa
      {
        title: 'STEPS.CONTRACT.TITLE',
      },
    ],
    route: RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_DATA.route,
  },
];
